<template>
  <public-profile
      :serviceProviderOccupationId="serviceProviderOccupationId"
      :profile="profile"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { SSRPageNotFoundError } from '@homeservices/tool-kit/errors';
import PublicProfile from './components/PublicProfile';

export default {
  name: 'pro-public-profile-super',
  components: {
    PublicProfile,
  },
  async prefetch ({ store, to }) {
    await store.dispatch('propublicprofile/fetch', to.params.serviceProviderOccupationId);
    if (!store.state.propublicprofile.profile) {
      throw new SSRPageNotFoundError();
    } else if (!store.state.propublicprofile.profile.eligible_for_public_profile) {
      let message = 'GENERIC-NOT-ELIGILE-PAGE';
      if (store.state.user.isPro) {
        const proIdOfOccupation = store.state.propublicprofile.profile.service_provider.identifier;
        if (store.state.user.me.id === Number(proIdOfOccupation)) {
          message = 'PROS-NOT-ELIGIBLE-PAGE';
        }
      }

      throw new Error(message);
    }
  },
  computed: {
    ...mapState('propublicprofile', [
      'profile',
    ]),
    ...mapState('user', [
      'isPro',
      'me',
    ]),
    serviceProviderOccupationId () {
      return this.$route.params.serviceProviderOccupationId;
    },
  },
  watch: {
    async serviceProviderOccupationId (val) {
      await this.fetch(val);
      if (!this.profile) {
        throw new SSRPageNotFoundError();
      } else if (!this.profile.eligible_for_public_profile) {
        let message = 'GENERIC-NOT-ELIGILE-PAGE';
        if (this.isPro) {
          const proIdOfOccupation = this.profile.service_provider.identifier;
          if (this.me.id === Number(proIdOfOccupation)) {
            message = 'PROS-NOT-ELIGIBLE-PAGE';
          }
        }

        throw new Error(message);
      }
    },
  },
  methods: {
    ...mapActions('propublicprofile', ['fetch']),
  },
};
</script>
